import api from './client';

export const getUsers = (params) => api.get('/users', { params });
export const getUser = (id) => api.get(`/users/${id}`);
export const inviteUser = (data) => api.post('/users/invite', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const updateRole = (id, data) => api.patch(`/users/${id}/role`, data);
export const deactivateUser = (id) => api.patch(`/users/${id}/deactivate`);
export const activateUser = (id) => api.patch(`/users/${id}/activate`);
